import { createSlice } from '@reduxjs/toolkit';

// Set the initial state values of the state object that this slice will manage
const INITIAL_STATE = {
  isGetReportingHistoryInProgress: false,
  isGetReportingHistorySuccess: false,
  reportingHistory: null, // raw data from the first licnese returned from /reportingHistoryByApplicationNumber or null
  reportingHistoryErrorMsg: '',

  isGetPropertyContactsInProgress: false,
  isGetPropertyContactsSuccess: false,
  propertyContacts: null, // raw data from  /peopleByApplicationNumbers
  propertyContactsErrorMsg: '',

  isGetPermitActionabilityInProgress: false,
  isGetPermitActionabilitySuccess: false,
  permitActionability: null, // raw data from  /permitActionability
  permitActionabilityErrorMsg: '',

  license: null,
  licneseInProgress: false,
  licneseSuccess: false,
};

// Define the slice and generate actions, reducers with createSlice
export const licenseViewSlice = createSlice({
  name: 'licenseView',
  initialState: INITIAL_STATE,
  reducers: {
    reportingHistoryStarted: (state) => {
      state.isGetReportingHistoryInProgress = true;
      state.isGetReportingHistorySuccess = false;
      state.reportingHistoryErrorMsg = '';
    },
    reportingHistorySucceeded: (state, action) => {
      state.isGetReportingHistoryInProgress = false;
      state.isGetReportingHistorySuccess = true;
      state.reportingHistory = action.payload;
      state.reportingHistoryErrorMsg = '';
    },
    reportingHistoryFailure: (state, action) => {
      state.isGetReportingHistoryInProgress = false;
      state.isGetReportingHistorySuccess = false;
      state.reportingHistory = [];
      state.reportingHistoryErrorMsg = action.payload;
    },

    propertyContactsStarted: (state) => {
      state.isGetPropertyContactsInProgress = true;
      state.isGetPropertyContactsSuccess = false;
      state.propertyContactsErrorMsg = '';
    },
    propertyContactsSucceeded: (state, action) => {
      state.isGetPropertyContactsInProgress = false;
      state.isGetPropertyContactsSuccess = true;
      state.propertyContacts = action.payload;
      state.propertyContactsErrorMsg = '';
    },
    propertyContactsErrorMsg: (state, action) => {
      state.isGetPropertyContactsInProgress = false;
      state.isGetPropertyContactsSuccess = false;
      state.propertyContacts = null;
      state.propertyContactsErrorMsg = action.payload;
    },

    permitActionabilityStarted: (state) => {
      state.isGetPermitActionabilityInProgress = true;
      state.isGetPermitActionabilitySuccess = false;
      state.permitActionabilityErrorMsg = '';
    },
    permitActionabilitySucceeded: (state, action) => {
      state.isGetPermitActionabilityInProgress = false;
      state.isGetPermitActionabilitySuccess = true;
      state.permitActionability = action.payload;
      state.permitActionabilityErrorMsg = '';
    },
    permitActionabilityErrorMsg: (state, action) => {
      state.isGetPermitActionabilityInProgress = false;
      state.isGetPermitActionabilitySuccess = false;
      state.permitActionability = null;
      state.permitActionabilityErrorMsg = action.payload;
    },

    resetLicenseViewState: (state) => INITIAL_STATE,
  },
});

// Export actions that were generated by createSlice
export const {
  reportingHistoryStarted,
  reportingHistorySucceeded,
  reportingHistoryFailure,
  propertyContactsStarted,
  propertyContactsSucceeded,
  propertyContactsFailure,
  permitActionabilityStarted,
  permitActionabilitySucceeded,
  permitActionabilityFailure,
  resetLicenseViewState,
} = licenseViewSlice.actions;

// Export combined reducer that was generated by createSlice
// (this is a single reducer which is a combination of all reducers in the slice... it basically puts them in a switch statement)
export default licenseViewSlice.reducer;
